// The long read's moment (#5195; founder pick A): halfway down a college
// page, after Deadlines, a compact block with the page's own figure and one
// action that opens the page's ONE Where do I stand card in place (free, no
// sign-in; no second form on the page). Shown to a signed-out visitor who
// has not run the card here, once 60 seconds have passed on the page or the
// card has scrolled out of view unused, whichever comes first (the Desk's
// answer to open question 6), once per page.
//
// Events: signup_moment {moment: long_read, payoff: figure, state:
// shown|clicked|dismissed}. A read started from here keeps the moment, so
// its box and the sign-in count as the long read's (StandCard `via`).
import React, { useEffect, useRef, useState } from 'react';
import useShownOnce from '../../hooks/useShownOnce';
import { track, EVENTS } from '../../services/analytics';
import { dismissMoment, isDismissed } from '../../services/signupMoments';
import { COPY } from '../../content/signupMoments';

// How long a visitor reads before the block may show.
export const LONG_READ_MS = 60 * 1000;
const MOMENT = 'long_read';

/** Whether the card is above the viewport (scrolled past), unused. */
function cardScrolledPast() {
    const card = typeof document !== 'undefined' && document.querySelector('[data-testid="college-stand"]');
    if (!card || typeof card.getBoundingClientRect !== 'function') return false;
    return card.getBoundingClientRect().bottom < 0;
}

export default function LongReadBlock({ line, active, onCheck, delayMs = LONG_READ_MS }) {
    const ref = useRef(null);
    const [due, setDue] = useState(false);
    const [gone, setGone] = useState(() => isDismissed(MOMENT));

    useEffect(() => {
        if (!active || due) return undefined;
        const timer = setTimeout(() => setDue(true), delayMs);
        const onScroll = () => { if (cardScrolledPast()) setDue(true); };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => { clearTimeout(timer); window.removeEventListener('scroll', onScroll); };
    }, [active, due, delayMs]);

    const live = active && due && !gone;
    const evt = (state) => track(EVENTS.SIGNUP_MOMENT, { moment: MOMENT, state, payoff: 'figure', variant: 'A' });
    useShownOnce(ref, live, () => evt('shown'));
    if (!live) return null;

    return (
        <aside ref={ref} data-testid="long-read-moment" aria-labelledby="long-read-moment-line"
            className="mt-8 rounded-2xl border-2 border-[#1A4D2E] bg-[#F0F7F1] p-4 sm:p-5">
            <p id="long-read-moment-line" className="text-base font-semibold leading-snug text-[#1A2E1F]">{line}</p>
            <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1">
                <button type="button" data-testid="long-read-moment-go"
                    onClick={() => { evt('clicked'); setGone(true); onCheck?.(); }}
                    className="min-h-[44px] rounded-full bg-[#1A4D2E] px-5 text-sm font-semibold text-[#FDFCF7] hover:bg-[#2D6B45] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B4532F] focus-visible:ring-offset-2">
                    {COPY.longReadGo}
                </button>
                <button type="button" data-testid="long-read-moment-not-now"
                    onClick={() => { evt('dismissed'); dismissMoment(MOMENT); setGone(true); }}
                    className="min-h-[44px] text-sm font-semibold text-[#4A4A4A] underline underline-offset-4 hover:text-[#1A4D2E] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B4532F]">
                    {COPY.notNow}
                </button>
            </div>
            <p className="mt-1 text-xs text-[#4A4A4A]">{COPY.longReadSmall}</p>
        </aside>
    );
}
